import { Box, Flex, Text } from '@chakra-ui/react';
import { HelperTooltip } from 'components/Tooltip';
import PropTypes from 'prop-types';
import { useMemo } from 'react';
import { buildMarketingMonthCashflowTable } from './calc/buildMarketingMonthCashflowTable';
import { fmtFundingPct, fmtMoneyTable } from './calc/formatters';

function formatCell(value, format) {
  if (value == null) {
    return '—';
  }
  if (format === 'pct') {
    return fmtFundingPct(value);
  }
  if (format === 'money') {
    return fmtMoneyTable(value);
  }
  return value;
}

function MarketingMonthCashflowSection({ calcResult, state }) {
  const table = useMemo(
    () => buildMarketingMonthCashflowTable(calcResult, state),
    [calcResult, state]
  );

  if (!table) {
    return null;
  }

  return (
    <Box className="card marketing-month-cashflow-section" mt={6}>
      <Box className="section-header">
        <Text fontWeight="semibold">Marketing cashflow by month</Text>
      </Box>
      <Box overflowX="auto" px={3} pb={3}>
        <table className="w-full marketing-plan-table marketing-month-cashflow-table">
          <thead>
            <tr>
              <th className="text-left">Metric</th>
              {table.columns.map((column) => (
                <th key={column.outputMonth} className="text-center">
                  {column.label}
                </th>
              ))}
            </tr>
          </thead>
          <tbody>
            {table.rows.map((row) => (
              <tr
                key={row.key}
                className={
                  row.highlight ? 'marketing-month-cashflow-net-row' : undefined
                }
              >
                <td>
                  <Flex align="center" gap={0} display="inline-flex">
                    {row.label}
                    {row.tooltip ? <HelperTooltip content={row.tooltip} /> : null}
                  </Flex>
                </td>
                {table.columns.map((column) => {
                  const value = column[row.key];
                  const isNegative = row.format === 'money' && Number(value) < 0;
                  return (
                    <td
                      key={`${row.key}-${column.outputMonth}`}
                      className={`text-right ${isNegative ? 'negative' : ''} ${
                        row.highlight ? 'font-semibold' : ''
                      }`}
                    >
                      {formatCell(value, row.format)}
                    </td>
                  );
                })}
              </tr>
            ))}
          </tbody>
        </table>
      </Box>
    </Box>
  );
}

MarketingMonthCashflowSection.propTypes = {
  calcResult: PropTypes.object.isRequired,
  state: PropTypes.object.isRequired,
};

export default MarketingMonthCashflowSection;
